module.exports = __webpack_public_path__ + "Roboto-ThinItalic.64ca718f48db91b27e8c.eot";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-ThinItalic.eot
// module chunks = 5